"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dialogFooterTokens = void 0;
const Global_1 = require("../../DesignSystem/tokens/Global");
const DesignToken_1 = __importDefault(require("../../DesignSystem/types/DesignToken"));
const dialogFooterPaddingVertical = new DesignToken_1.default({
    name: 'dialog-footer-paddingVertical',
    parent: [Global_1.globalTokens.spacingM, Global_1.globalTokens.oldTokens.sizeSpaceM]
});
const dialogFooterBorderWidth = new DesignToken_1.default({
    name: 'dialog-footer-borderWidth',
    parent: [Global_1.globalTokens.borderWidthS, Global_1.globalTokens.oldTokens.borderWidthS]
});
const dialogFooterBorderColor = new DesignToken_1.default({
    name: 'dialog-footer-borderColor',
    parent: [Global_1.globalTokens.colorStrokeDefaultDefault, Global_1.globalTokens.oldTokens.colorBorderMain]
});
const dialogFooterControlsIndent = new DesignToken_1.default({
    name: 'dialog-footer-controlsIndent',
    parent: [Global_1.globalTokens.spacingS, Global_1.globalTokens.oldTokens.sizeSpaceM]
});
exports.dialogFooterTokens = {
    dialogFooterPaddingVertical,
    dialogFooterBorderWidth,
    dialogFooterBorderColor,
    dialogFooterControlsIndent
};
//# sourceMappingURL=DialogFooter.js.map